import { gql } from 'graphql-request';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import { request } from '@/utilities/graphQLClient';

type QueryContext = QueryFunctionContext<
  [string, Portfolio['id'], { startTimestamp: number; endTimestamp: number }]
>;

export interface QueryResponse {
  errors?: Error[];
  samplePortfolio: {
    performance: Record<string, number>;
  };
}

export const queryFn = async ({
  queryKey: [_, portfolioId, { startTimestamp, endTimestamp }],
}: QueryContext) => {
  const response = await request<QueryResponse>(
    gql`
      query getDemoPortfolioPerformanceTimeseries(
        $portfolioId: String!
        $startTimestamp: Float!
        $endTimestamp: Float!
      ) {
        samplePortfolio(id: $portfolioId) {
          performance(
            startTimestamp: $startTimestamp
            endTimestamp: $endTimestamp
          )
        }
      }
    `,
    { portfolioId, startTimestamp, endTimestamp }
  );

  if ('samplePortfolio' in response) {
    return response.samplePortfolio.performance;
  }
};
